// Bootstrap admin email(s). Anyone whose user doc has `role === 'admin'` is also
// admin — this list exists so the original admin doesn't get locked out if their
// own user doc lacks the role flag.
// Twin copies (do not change here without changing there): isAdmin() in
// firestore.rules and the admin allowlist in functions/index.js.
export const LEGACY_ADMIN_EMAILS = [
  'gabrielapiorini@gmail.com',
  'giu.freitas@the-open-mat.com',
  'pietra.siqueira@the-open-mat.com',
];

// Email casing is not guaranteed by the auth provider, so compare lowercased.
export const isLegacyAdminEmail = (email) =>
  LEGACY_ADMIN_EMAILS.includes((email || '').toLowerCase());
